import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth token lives in an httpOnly cookie set by the backend on login/register.
// `withCredentials: true` makes the browser send that cookie on every request.
const api = axios.create({ baseURL: API, withCredentials: true });

export default api;
